export function detectMobileDevice() {
  const coarsePointer = window.matchMedia("(pointer: coarse)").matches;
  const smallViewport = Math.min(window.innerWidth, window.innerHeight) < 900;
  const userAgentMatch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  return coarsePointer || smallViewport || userAgentMatch;
}

export function getRendererProfile() {
  const isMobile = detectMobileDevice();
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return {
    isMobile,
    prefersReducedMotion,
    usePostProcess: !isMobile && !prefersReducedMotion,
    maxPixelRatio: isMobile ? 1.25 : 1.8,
    particleCount: isMobile ? 1200 : 3400,
    geometryDetail: isMobile ? 22 : 48
  };
}
